module.exports = __webpack_public_path__ + "img/map.ed489c5b.svg";